/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Output_LabelInputs */

const en_xml_output_label = /** @type {(inputs: Xml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML Output`)
};

const ko_xml_output_label = /** @type {(inputs: Xml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML 출력`)
};

const ja_xml_output_label = /** @type {(inputs: Xml_Output_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML出力`)
};

/**
* | output |
* | --- |
* | "XML Output" |
*
* @param {Xml_Output_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const xml_output_label = /** @type {((inputs?: Xml_Output_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Output_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_output_label(inputs)
	if (locale === "ko") return ko_xml_output_label(inputs)
	return ja_xml_output_label(inputs)
});